import ExamDetails from "src/components/NewComponents/Views/Details/ExamDetails";
import { ExamTypes } from "src/types/enums";

interface BlockedDetailsProps {
	lesson: any;
	className?: string;
}

export const BlockedDetails = ({ lesson, className }: BlockedDetailsProps) => {
	return (
		<ExamDetails
			className={className}
			row={{
				name: lesson.name,
				score: 0,
				totalQuestions: lesson.itemsIds.length,
				resolvedQuestions: 0,
				type: ExamTypes.COURSE,
				status: lesson.status,
			}}
		/>
	);
};
